import { render } from "./ProfileDataView.vue?vue&type=template&id=44a2c915&scoped=true"
import script from "./ProfileDataView.vue?vue&type=script&lang=js"
export * from "./ProfileDataView.vue?vue&type=script&lang=js"

import "./ProfileDataView.vue?vue&type=style&index=0&id=44a2c915&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a2c915"]])

export default __exports__